"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelType = exports.MessageSubType = exports.MessageType = exports.AttachmentInvalidReason = exports.AttachmentType = exports.MessageActionType = void 0;
exports.MessageActionType = {
    Text: 'text',
    OpenUrl: 'open_url',
};
exports.AttachmentType = {
    File: 'file',
    Image: 'image',
    Media: 'media',
    Invalid: 'invalid',
};
exports.AttachmentInvalidReason = {
    InvalidSize: 'invalid_size',
    InvalidType: 'invalid_type',
};
exports.MessageType = {
    Message: 'message',
    Event: 'event',
    Help: 'help',
};
exports.MessageSubType = {
    Agent: 'agent',
    Contact: 'contact',
    Trigger: 'trigger',
    Bot: 'bot',
    System: 'system',
    AgentExternal: 'agent_external',
    FoundEmail: 'found_email',
    ChatResolve: 'chat_resolve',
};
exports.ChannelType = {
    Default: 'default',
    Email: 'email',
    FacebookMessenger: 'facebook_messenger',
    Smartsupp: 'smartsupp',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZW51bXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxpQkFBaUIsR0FBRztJQUNoQyxJQUFJLEVBQUUsTUFBTTtJQUNaLE9BQU8sRUFBRSxVQUFVO0NBQ1YsQ0FBQTtBQUdHLFFBQUEsY0FBYyxHQUFHO0lBQzdCLElBQUksRUFBRSxNQUFNO0lBQ1osS0FBSyxFQUFFLE9BQU87SUFDZCxLQUFLLEVBQUUsT0FBTztJQUNkLE9BQU8sRUFBRSxTQUFTO0NBQ1QsQ0FBQTtBQUdHLFFBQUEsdUJBQXVCLEdBQUc7SUFDdEMsV0FBVyxFQUFFLGNBQWM7SUFDM0IsV0FBVyxFQUFFLGNBQWM7Q0FDbEIsQ0FBQTtBQUdHLFFBQUEsV0FBVyxHQUFHO0lBQzFCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLEtBQUssRUFBRSxPQUFPO0lBQ2QsSUFBSSxFQUFFLE1BQU07Q0FDSCxDQUFBO0FBR0csUUFBQSxjQUFjLEdBQUc7SUFDN0IsS0FBSyxFQUFFLE9BQU87SUFDZCxPQUFPLEVBQUUsU0FBUztJQUNsQixPQUFPLEVBQUUsU0FBUztJQUNsQixHQUFHLEVBQUUsS0FBSztJQUNWLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLGFBQWEsRUFBRSxnQkFBZ0I7SUFDL0IsVUFBVSxFQUFFLGFBQWE7SUFDekIsV0FBVyxFQUFFLGNBQWM7Q0FDbEIsQ0FBQTtBQUdHLFFBQUEsV0FBVyxHQUFHO0lBQzFCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLEtBQUssRUFBRSxPQUFPO0lBQ2QsaUJBQWlCLEVBQUUsb0JBQW9CO0lBQ3ZDLFNBQVMsRUFBRSxXQUFXO0NBQ2IsQ0FBQSJ9